var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ck-style"},[(_vm.error)?_c('div',[_c('ErrorView')],1):_c('router-view',{staticClass:"router-view-container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }